import { combineReducers } from 'redux';
import { reducer as authReducer } from './modules/Auth';

const createRootReducers = () => {
  const rootReducers = combineReducers({
    auth: authReducer,
  });

  return rootReducers;
};

export default createRootReducers;
